import React from 'react';
import { ActivityExecutionService } from '@services/actions/ActivityExecutionService';
import { ExecutorPickerModal } from '../parts/ExecutorPickerModal';
import { IDelegateProps } from './IDelegateProps';

export const DelegateModal: React.FC<IDelegateProps> = (props: IDelegateProps) => {
    const serv = new ActivityExecutionService();

    return (
        <ExecutorPickerModal
            {...props}
            showComment
            guardExecutor
            loadModel={() => serv.getDelegateModel(props.actionKey, props.activityId)}
            submit={(form) => serv.saveDelegate(props.actionKey, props.activityId, form?.executor, form?.comment)}
        />
    );
};
